import { useSetAtom } from "jotai";
import {
  setAddEditEmployeeAtom,
  setAssignEmployeeModalAtom,
  setConfirmationModalAtom,
  setModalCloseAtom,
} from "atoms/modalAtom/modalAtom";
import { useEmployeesState } from "atoms/employeesAtom";

import { Button } from "components/Button/Button";
import { HorizontalSpace } from "components/HorizontalSpace/HorizontalSpace";

import { useDeleteEmployee } from "../api";

export const EmployeesFooter = (): JSX.Element => {
  const { employeesState } = useEmployeesState();
  const closeModal = useSetAtom(setModalCloseAtom);
  const setConfirmationModal = useSetAtom(setConfirmationModalAtom);
  const setAssignEmployeeModal = useSetAtom(setAssignEmployeeModalAtom);
  const setAddEditEmployee = useSetAtom(setAddEditEmployeeAtom);

  const { mutate: deleteEmployee } = useDeleteEmployee();

  const onConfirm = () => {
    deleteEmployee(employeesState.activeItem?.usersid || "");

    closeModal();
  };

  const handleDelete = () => {
    if (employeesState.activeItem) {
      setConfirmationModal({
        title: `Вы действительно хотите удалить сотрудника "${employeesState.activeItem?.name}"?`,
        onConfirm,
      });
    }
  };

  const handleApply = () => {
    if (employeesState.activeItem) {
      setAssignEmployeeModal();
    }
  };

  const handleAdd = () => {
    if (employeesState.activeGroupItem) {
      setAddEditEmployee({ isEdit: false });
    }
  };

  return (
    <div className="flex flex-row ">
      <Button
        icon="plus"
        onClick={handleAdd}
        disabled={!employeesState.activeGroupItem}
      >
        Добавить сотрудника
      </Button>
      <HorizontalSpace size={11} />
      <Button
        onClick={handleApply}
        icon="move"
        disabled={!employeesState.activeItem}
      >
        Назначить
      </Button>
      <HorizontalSpace size={11} />
      <Button
        icon="delete"
        onClick={handleDelete}
        disabled={!employeesState.activeItem}
      />
    </div>
  );
};
